module.exports = __webpack_public_path__ + "static/media/STANDARD_END_FAST.dc12ef98.mp3";